import {
  Evaluation,
  EvaluationApiResponse,
} from '@/apis/evaluations/types/evaluationsApi';
import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';

export const evaluationFromApiAdapter = (
  evaluation: EvaluationApiResponse,
): Evaluation | null => {
  if (!evaluation) return null;
  return {
    empId: evaluation.EmpID,
    name: evaluation.Name,
    outageId: evaluation.OutageID,
    outageName: evaluation.OutageName,
    evaluatorName: evaluation.EvaluatorName,
    evalDate: evaluation.EvalDate,
    eval: evaluation.Eval,
    notes: evaluation.Notes ?? null,
  };
};

export const millwrightEvaluationsFromApiAdapter = (
  response: PaginatedResponseFromApi<EvaluationApiResponse>,
): PaginatedResponse<Evaluation | null> => {
  return {
    results: response?.results.map(evaluationFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};
